import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=284c0509&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=284c0509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c0509",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284c0509')) {
      api.createRecord('284c0509', component.options)
    } else {
      api.reload('284c0509', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=284c0509&scoped=true&", function () {
      api.rerender('284c0509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-255CJPeUaHTlU/JS/comp/GuestBox.vue"
export default component.exports